<template>

        <div class="p404 pa-5">
            <div>
                <h1 class="display-4 font-weight-black">404</h1>
                <p class=".display-3">
                    <v-icon>error</v-icon>
                    Страница не найдена
                </p>
            </div>

        </div>


</template>

<script>
    export default {
        name: '404',
        metaInfo: {
            title: '404 | Страница не найдена',
        },
    }
</script>

<style lang="scss" scoped>
.p404{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100% !important;
}
</style>
